import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/home/main"));

const Home = () => {
  return (
    <Layout pageHeading="Home">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default Home;